export default __webpack_public_path__ + "static/media/media.fcf05f6f.jpg";